export const COMPANY_TYPE_INDIVIDUAL = 0
export const COMPANY_TYPE_BUSINESS = 1
export const COMPANY_TYPE_ENTERPRISE = 2
export const COMPANY_TYPE_ENTERPRISE_NO_NDS = 3
export const COMPANY_TYPE_BUSINESS_NDS = 4

export const COMPANY_TYPES_WITH_INN = [
  COMPANY_TYPE_INDIVIDUAL,
  COMPANY_TYPE_BUSINESS,
  COMPANY_TYPE_BUSINESS_NDS,
  COMPANY_TYPE_ENTERPRISE,
]

export const COMPANY_TYPES_WITH_EDRPOU = [
  COMPANY_TYPE_BUSINESS_NDS,
  COMPANY_TYPE_ENTERPRISE,
  COMPANY_TYPE_ENTERPRISE_NO_NDS,
]



// WEBPACK FOOTER //
// ./resources/assets/js/constants/companyTypes.js